import formatMoney from "../../formatMoney";
import { filterByMonthYear, getMonthNumber } from "../../monthUtils.js";

export function getTotalGross(objects, month, year) {
  const filteredObjects = filterByMonthYear(
    objects,
    getMonthNumber(month),
    year,
  );

  const totalGross = filteredObjects.reduce((acc, obj) => {
    const numericNet = parseFloat(obj.gross.replace(/,/g, ""));
    return acc + (isNaN(numericNet) ? 0 : numericNet);
  }, 0);

  return formatMoney(totalGross);
}

export function getPurchaseCount(objects, month, year) {
  return filterByMonthYear(objects, getMonthNumber(month), year).length;
}

export function getStatusBackgroundColor(objects, month, year) {
  //filtering objects by month and year
  const filteredObjects = filterByMonthYear(
    objects,
    getMonthNumber(month),
    year,
  );

  //getting only vatable objects
  const vatableObjects = filteredObjects.filter(
    (data) => data.status !== "non-vat",
  );

  if (vatableObjects.length === 0) {
    return undefined;
  }

  const hasForAudit = vatableObjects.some(
    (obj) => obj?.status && obj.status.includes("for_audit"),
  );

  if (hasForAudit) {
    return "#fff3cd";
  }

  const allAudited = vatableObjects.every((obj) => obj?.status === "audited");

  if (allAudited) {
    return "#cfe2ff";
  }

  return undefined;
}

export function areAllObjectsPending(objects, month, year) {
  const objectByMonth = filterByMonthYear(objects, getMonthNumber(month), year);

  const filteredObjects = objectByMonth.filter(
    (obj) => obj.status !== "non-vat",
  );

  if (filteredObjects.length === 0) {
    return filteredObjects.length;
  }

  return filteredObjects.every((obj) => obj?.status === "pending");
}
